'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useState } from 'react';
import useSWR from 'swr';
import EmptyFollowingCard from '@/app/[locale]/(worlds)/profile/components/EmptyFollowingCard';
import RecommendAvatarCard from '@/app/[locale]/(worlds)/profile/components/RecommendAvatarCard';
import { useDraggingScroll } from '@/hooks/useDraggingScroll';
import { useScrollable } from '@/hooks/useScrollable';
import { cn } from '@/lib/utils';
import { Creator, getRecommendCreators } from '@/services/cms';
export default function RecommendCreators() {
  const $ = _c(37);
  const {
    data: recommendCreatorsData
  } = useSWR("recommendCreators", _temp2);
  let t0;
  if ($[0] !== recommendCreatorsData?.results) {
    t0 = recommendCreatorsData?.results || [];
    $[0] = recommendCreatorsData?.results;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const recommendCreators = t0;
  const {
    containerRef,
    canScrollLeft,
    canScrollRight,
    scrollLeft,
    scrollRight
  } = useScrollable();
  const {
    bind,
    disableDrag,
    onMouseDown,
    onMouseUp
  } = useDraggingScroll(containerRef);
  const [isHovered, setIsHovered] = useState(false);
  let t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsHovered(true);
    t2 = () => setIsHovered(false);
    t3 = <EmptyFollowingCard />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== bind) {
    t4 = bind();
    $[5] = bind;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = !disableDrag && (canScrollLeft || canScrollRight);
  const t6 = !disableDrag && (canScrollLeft || canScrollRight);
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = cn("no-scrollbar flex gap-4 select-none max-lg:overflow-auto max-lg:scroll-smooth md:gap-5", {
      "active:cursor-grabbing": t5,
      "cursor-grab": t6
    });
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== recommendCreators) {
    t8 = recommendCreators.map(_temp3);
    $[10] = recommendCreators;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = isHovered && canScrollLeft;
  const t10 = !canScrollLeft;
  let t11;
  if ($[12] !== t10 || $[13] !== t9) {
    t11 = cn("group bg-vive-primary-70 z-floating absolute bottom-[60px] left-5 hidden size-8 -translate-y-1/2 cursor-pointer place-items-center rounded-full opacity-0 transition-opacity duration-300 md:grid md:size-[52px]", {
      "opacity-100": t9,
      "opacity-0": t10
    });
    $[12] = t10;
    $[13] = t9;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <ChevronLeft className="stroke-vive-primary-30 group-hover:stroke-vive-primary-0 size-[36px] transition-all" />;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== scrollLeft || $[17] !== t11) {
    t13 = <div className={t11} onClick={scrollLeft}>{t12}</div>;
    $[16] = scrollLeft;
    $[17] = t11;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const t14 = isHovered && canScrollRight;
  const t15 = !canScrollRight;
  let t16;
  if ($[19] !== t14 || $[20] !== t15) {
    t16 = cn("group bg-vive-primary-70 z-floating absolute right-5 bottom-[60px] hidden size-8 -translate-y-1/2 cursor-pointer place-items-center rounded-full opacity-0 transition-opacity duration-300 md:grid md:size-[52px]", {
      "opacity-100": t14,
      "opacity-0": t15
    });
    $[19] = t14;
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== scrollRight) {
    t17 = <ChevronRight onClick={scrollRight} className="stroke-vive-primary-30 group-hover:stroke-vive-primary-0 size-[36px] transition-all" />;
    $[22] = scrollRight;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== scrollRight || $[25] !== t16 || $[26] !== t17) {
    t18 = <div className={t16} onClick={scrollRight}>{t17}</div>;
    $[24] = scrollRight;
    $[25] = t16;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== containerRef || $[29] !== onMouseDown || $[30] !== onMouseUp || $[31] !== t13 || $[32] !== t18 || $[33] !== t4 || $[34] !== t7 || $[35] !== t8) {
    t19 = <div className="relative flex flex-col gap-4 md:gap-5" onMouseEnter={t1} onMouseLeave={t2}>{t3}<div {...t4} ref={containerRef} className={t7} onMouseDown={onMouseDown} onMouseUp={onMouseUp}>{t8}{t13}{t18}</div></div>;
    $[28] = containerRef;
    $[29] = onMouseDown;
    $[30] = onMouseUp;
    $[31] = t13;
    $[32] = t18;
    $[33] = t4;
    $[34] = t7;
    $[35] = t8;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  return t19;
}
function _temp3(creator) {
  return <RecommendAvatarCard key={creator.id} cardInfo={creator} />;
}
function _temp2() {
  return getRecommendCreators().then(_temp);
}
function _temp(res) {
  return res?.results;
}